if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Declaration uploader
         * Functionality for uploading declarations
         *
         * Makes use of jQuery File Upload plugin (https://github.com/blueimp/jQuery-File-Upload/wiki)
         *
         * @param element - jQuery object of containing (sub)form (not required to be of <form> element)
         */
        ZZ.DeclarationUploader = function(element) {
            var base = this;
            base.MAXIMUM_NUMBER_OF_UPLOAD_ITEMS = 6;

            base.element = element;
            base.fileinput = base.element.find("[type=file]");
            base.url =
                base.element.closest("form").attr("data-async-action") ||
                base.element.closest("form").attr("action");
            base.messageHandler = new ZZ.MessageHandler(
                base.element,
                "message-error"
            );
            if (window.arryUploadloader === undefined) {
                window.arryUploadloader = [];
            }
            if (window.nextButton === undefined) {
                window.nextButton = base.element
                    .closest("form")
                    .find('[name="next"]');
                base.enableOrDisableNextButton();
            }
            base.initFileUploader();
            base.assignListeners();
            base.toggleDisplayFileInputAndNotification();
        };

        ZZ.DeclarationUploader.prototype = {
            initFileUploader: function() {
                var base = this;
                // add copy id specific for backend
                var uploadUrl = base.element.attr("data-copy-id")
                    ? base.url + "?nota=" + base.element.attr("data-copy-id")
                    : base.url;
                base.fileinput.fileupload({
                    dataType: "json",
                    url: uploadUrl,

                    add: function(e, fileData) {
                        var file = fileData.files[0];
                        // (improvement) - use html template instead of code below to generate file progress
                        var filelist = base.element.find(".filelist");
                        var newItem = $("<li></li>");
                        var header = $(
                            "<h4>" + base.escapeHtml(file.name) + "</h4>"
                        );
                        var status = $('<span class="status">laden</span>');
                        var deleteLink = $(
                            '<a class="delete" href="#" data-delete-method="GET">verwijder bestand</a>'
                        );
                        var progressbar = $(
                            '<div class="progress"><div class="bar"></div></div>'
                        );
                        base.messageHandler.hideMessage();
                        newItem.append(header);
                        newItem.append(progressbar);
                        newItem.append(status);
                        newItem.append(deleteLink);
                        filelist.append(newItem);
                        deleteLink.on("click", function(e) {
                            e.preventDefault();
                            base.deleteFile($(this), newItem);
                        });
                        fileData.context = newItem;
                        fileData.submit();
                        //during uploading nextbutton must be disabled
                        window.arryUploadloader.push(base.fileinput);
                        base.enableOrDisableNextButton();
                    },

                    progress: function(e, data) {
                        var progress = parseInt(
                            (data.loaded / data.total) * 100,
                            10
                        );
                        data.context.find(".bar").css("width", progress + "%");
                    },

                    done: function(e, data) {
                        //after uploading nextbutton must be enabled
                        window.arryUploadloader.pop();
                        base.enableOrDisableNextButton();

                        // loading complete
                        var item = data.context;
                        var json = data.result;

                        // reload page if result is useless (possible issue in older IE, where the result is posted in an iframe)
                        // -- NB this is a workaround for an issue that seems to be a security problem. IE<=9 makes use of an hidden iframe (see jquery.iframe-transport.js) to enable async file upload. It returns the result in the iframe, but the access to the content of this iframe is denied and returns 'undefined'. As of yet unknown why this is the case.
                        // --    update: access denied due to "X-Frame-Options DENY" security setting in http header, set by server to prevent sending content to a framed environment. Solved on server for this specific case (MIJNZZ-2484), but keeping this check for fallback purpose.
                        if (json === undefined || typeof json === "undefined") {
                            document.location.reload();
                            return;
                        }

                        // if file is invalid, a "message" is returned in json
                        if (typeof json.message !== "undefined") {
                            base.failedUpload(item, json.message);
                        } else {
                            base.messageHandler.hideMessage();
                            item.addClass("done");
                            item.find(".status").text("voltooid");
                            if (typeof json.delete_url !== "undefined") {
                                var deleteBtn = item.find(".delete");
                                deleteBtn.attr("href", json.delete_url);
                                deleteBtn.attr(
                                    "data-delete-method",
                                    json.delete_type
                                );
                            }

                            base.toggleDisplayFileInputAndNotification();
                        }
                    },

                    fail: function(e, data) {
                        //after uploading failed nextbutton must be enabled
                        window.arryUploadloader.pop();
                        base.enableOrDisableNextButton();
                        base.failedUpload(
                            data.context,
                            "Uploaden van bestand is mislukt, probeert u het later nog eens."
                        );
                    }
                });
            },

            assignListeners: function() {
                var base = this;

                $(window).on("zz_delete_copy", function(e, declarationForm) {
                    if (base.element[0] === declarationForm) {
                        base.deleteAllFiles();
                    }
                });

                // init delete functionality in case previous uploads are prefilled on page
                base.element.find(".delete").on("click", function(e) {
                    e.preventDefault();
                    var deleteBtn = $(this);
                    var item = deleteBtn.parents("li:first");
                    base.deleteFile(deleteBtn, item);
                });
            },

            deleteFile: function(button, item) {
                var base = this;
                base.messageHandler.hideMessage();
                button.parent().addClass("loading");
                var requestType = button.attr("data-delete-method") || "GET";
                //during uploading nextbutton must be disabled
                window.arryUploadloader.push(base.fileinput);
                base.enableOrDisableNextButton();
                $.ajax({
                    url: button.attr("href"),
                    type: requestType,
                    redirLogout: true /* redirect in case logged out (redirect-proxy.js) */,

                    success: function(response) {
                        button.parent().removeClass("loading");
                        item.slideUp(200, function() {
                            $(this).remove();

                            base.toggleDisplayFileInputAndNotification();
                        });
                        //after uploading nextbutton must be enabled
                        window.arryUploadloader.pop();
                        base.enableOrDisableNextButton();
                    },

                    error: function() {
                        button.parent().removeClass("loading");
                        base.messageHandler.showMessage(
                            "Verwijderen mislukt. Probeer het later nog eens."
                        );
                        //after uploading nextbutton must be enabled
                        window.arryUploadloader.pop();
                        base.enableOrDisableNextButton();
                    }
                });
            },

            deleteAllFiles: function() {
                this.form.find(".delete").trigger("click");
            },

            failedUpload: function(item, message) {
                var base = this;
                item.remove();
                base.messageHandler.showMessage(message);
            },

            enableOrDisableNextButton: function() {
                if (window.arryUploadloader.length === 0) {
                    //enable
                    window.nextButton.removeAttr("disabled");
                } else {
                    //disable
                    window.nextButton.attr("disabled", "disabled");
                }
            },

            escapeHtml: function(rawStr) {
                return rawStr.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
                    return "&#" + i.charCodeAt(0) + ";";
                });
            },

            getHasMaximumNumberOfUploadItems: function() {
                const base = this;
                const filelist = base.element.find(".filelist");

                const numberOfFiles = filelist[0].children.length;
                return numberOfFiles >= base.MAXIMUM_NUMBER_OF_UPLOAD_ITEMS;
            },

            toggleDisplayFileInputAndNotification: function() {
                const base = this;

                const dataFileInput = base.element.find("[data-file-input]");
                const notificationMaximumNumberOfUploadItems = base.element.find(
                    "[data-notification-maximum-number-of-upload-items]"
                );

                if (base.getHasMaximumNumberOfUploadItems()) {
                    // Hide data-file-input
                    dataFileInput.addClass("is-hidden");

                    // Show notification message
                    notificationMaximumNumberOfUploadItems.removeClass(
                        "is-hidden"
                    );
                } else {
                    // Show data-file-input
                    dataFileInput.removeClass("is-hidden");

                    // Hide notification message
                    notificationMaximumNumberOfUploadItems.addClass(
                        "is-hidden"
                    );
                }
            }
        };
    })(jQuery);
}
